export interface NavItem {
  label: string;
  href: string;
}

export interface TickerItem {
  tag: string;
  text: string;
  hot: number;
}

export interface FeatureBlock {
  kicker: string;
  title: string;
  sub: string;
  whoTitle: string;
  who: string;
  whyTitle: string;
  why: string;
  focusTitle: string;
  focus: string;
  progressTitle: string;
  progress: string;
  note: string;
  imageAlt: string;
}

export interface Category {
  id: string;
  name: string;
  emoji: string;
  desc: string;
  count: number;
  tone: 'primary' | 'accent' | 'secondary';
}

export interface RankItem {
  rank: number;
  title: string;
  cat: string;
  heat: number;
  isUp: boolean;
  delta: string;
}

export interface NewsItem {
  id: string;
  cat: string;
  title: string;
  summary: string;
  time: string;
  reads: string;
  img: string;
  trend: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface ReviewItem {
  name: string;
  role: string;
  text: string;
  stars: number;
}

export const navItems: NavItem[] = [
  { label: '今日焦点', href: '#focus' },
  { label: '瓜分赛道', href: '#track' },
  { label: '热门瓜榜', href: '#rank' },
  { label: '最新瓜闻', href: '#latest' },
  { label: '吃瓜小课堂', href: '#learn' },
  { label: '关于我们', href: '#about' },
];

export const tickerTopics: TickerItem[] = [
  { tag: 'TOP1', text: '选秀舞台名场面二创刷屏，播放量一夜破千万', hot: 986 },
  { tag: 'TOP2', text: '热播剧收官幕后花絮冲上热搜，观众排队求第二季', hot: 912 },
  { tag: 'TOP3', text: '新晋女主的机场私服被同款博主逐件扒出', hot: 847 },
  { tag: 'TOP4', text: '综艺名场面反复出圈，网友自发做起“显微镜考据”', hot: 763 },
  { tag: 'TOP5', text: '电影撤档风波后续发酵，主创直播回应全程高能', hot: 701 },
  { tag: 'TOP6', text: '年度颁奖礼红毯造型盘点，哪套能封神引发激辩', hot: 658 },
];

export const featured: FeatureBlock = {
  kicker: '头号大瓜 · 一文看懂',
  title: '热播综艺「名场面」为何全网刷屏？这一瓜讲了谁、因何被议论、焦点在哪',
  sub: '别再翻一堆帖子了，这一页帮你理清今日大瓜的来龙去脉——这条话题到底围绕谁展开、为什么突然被顶上热搜、大家争的焦点是什么，以及目前最新进度走到哪一步。',
  whoTitle: '这瓜讲的是谁',
  who: '核心是某档现象级竞演综艺里几位参赛者与飞行嘉宾在节目中的一段即兴互动。整个讨论围绕“当红小花的新舞台风格”“人气选手的临时加戏”以及制作组“是否刻意剪辑”三条线展开，并未指向任何实锤对象，更多是观众对节目编排的集体联想。',
  whyTitle: '因为什么被议论',
  why: '导火索是一段被截出的后台花絮：镜头里气氛一度安静，字幕又打出“尽请期待”的悬念词。结合当期播放量创新高，观众觉得是节目在“埋线炒热”；随后多位现场观众晒出不同视角的场记，支持与反对两种解读迅速对立，话题因此连环冲上多个平台热搜。',
  focusTitle: '目前关注的焦点',
  focus: '争议焦点集中在三处：一是节目剪辑是否刻意放大了误会；二是当事人有没有在社交平台“暗戳戳回应”；三是这类“人设叙事”是否透支观众热情。目前官方与当事方均未正式表态，评论区仍在各执一词。',
  progressTitle: '最新进展',
  progress: '截稿前，节目组发布了一份不含具体指向的“感谢关注”声明，多个现场视角视频仍在持续扩散。按过往经验，这类热度通常会在 48 小时内降温，建议先让子弹飞一会儿。',
  note: '理性吃瓜提醒：以上为公开讨论的梳理与客观转述，不构成对任何单位或个人的定性与指认，请以官方与当事方说明为准，不传谣、不网暴。',
  imageAlt: '综艺演播厅暖色舞台灯光下的名场面现场',
};

export const categories: Category[] = [
  { id: 'star', name: '明星动态', emoji: '🎬', desc: '作品官宣、行程与台前幕后的新鲜事', count: 36, tone: 'primary' },
  { id: 'variety', name: '综艺名场面', emoji: '🎤', desc: '热门节目出圈片段与二次创作', count: 41, tone: 'accent' },
  { id: 'trend', name: '流行话题', emoji: '🔥', desc: '穿搭、梗图、网络热词与年轻文化', count: 28, tone: 'secondary' },
  { id: 'event', name: '圈内要闻', emoji: '📣', desc: '颁奖、档期、撤档与产业风向', count: 19, tone: 'secondary' },
];

export const hotRank: RankItem[] = [
  { rank: 1, title: '热播综艺“名场面”出圈后，节目方回应引热议', cat: '综艺名场面', heat: 986, isUp: true, delta: '较昨日 +3.2%' },
  { rank: 2, title: '新晋女演员机场私服被逐件扒出同款', cat: '明星动态', heat: 912, isUp: true, delta: '较昨日 +2.8%' },
  { rank: 3, title: '收官热剧观众请愿开拍第二季', cat: '圈内要闻', heat: 847, isUp: false, delta: '较昨日 -0.9%' },
  { rank: 4, title: '颁奖礼红毯造型榜单出炉，谁穿对了成焦点', cat: '圈内要闻', heat: 763, isUp: true, delta: '较昨日 +1.6%' },
  { rank: 5, title: '“显微镜式”逐帧考据成新式追剧方式', cat: '流行话题', heat: 701, isUp: false, delta: '较昨日 -2.1%' },
  { rank: 6, title: '爆款主题曲翻唱挑战席卷短视频平台', cat: '流行话题', heat: 658, isUp: true, delta: '较昨日 +4.0%' },
];

export const newsFeed: NewsItem[] = [
  { id: 'n1', cat: '综艺名场面', title: '“名场面”二创视频破千万播放，网友排队考古原片', summary: '一段被反复截取的节目互动成为本周流量王。二次创作者们用慢放、加字幕、拆机位的方式重新解读，甚至带动原片播放量同步上涨。', time: '今天 09:24', reads: '12.6 万', trend: '+38%', img: 'https://readdy.ai/api/search-image?query=warm%20television%20studio%20stage%20with%20amber%20spotlights%20and%20soft%20haze%2C%20empty%20red%20seats%20in%20foreground%2C%20cinematic%20backstage%20moment%2C%20editorial%20magazine%20tone&width=640&height=480&seq=feed-variety-01&orientation=landscape' },
  { id: 'n2', cat: '明星动态', title: '新晋女主机场私服爆火，逐件同款链接被整理成清单', summary: '一身低饱和色系穿搭因“松弛又减龄”被刷屏。时尚博主按外套、内搭、鞋包逐件拆解并标注价格区间，评论区高呼“普通人也能穿出氛围感”。', time: '今天 08:51', reads: '9.8 万', trend: '+21%', img: 'https://readdy.ai/api/search-image?query=minimal%20outfit%20flatlay%20in%20warm%20cream%20beige%20and%20coral%20tone%20on%20soft%20textured%20fabric%2C%20casual%20chic%20streetwear%20lookbook%2C%20editorial%20photography&width=640&height=480&seq=feed-style-01&orientation=landscape' },
  { id: 'n3', cat: '圈内要闻', title: '收官热剧晒出幕后花絮，观众集体“求二季”登热搜', summary: '制作方释出一支含NG与现场笑场的杀青花絮，主创同框互动有爱。话题阅读量快速攀升，多个平台出现请愿话题，目前官方暂未回应续订计划。', time: '昨天 22:03', reads: '15.2 万', trend: '+45%', img: 'https://readdy.ai/api/search-image?query=cozy%20warm%20film%20set%20behind%20the%20scenes%20with%20soft%20practical%20lights%20and%20director%20monitor%2C%20golden%20hour%20atmosphere%2C%20editorial%20storytelling&width=640&height=480&seq=feed-drama-01&orientation=landscape' },
  { id: 'n4', cat: '流行话题', title: '逐帧考据成新式追剧姿势：看剧也能“显微镜”', summary: '观众不再只关心结局，转而像做研究一样拆解服装细节、背景道具与镜头构图。这种“高浓度”看剧方式催生大量解析帖，也被戏称为“硬核追剧”。', time: '昨天 19:47', reads: '7.3 万', trend: '+16%', img: 'https://readdy.ai/api/search-image?query=macro%20detail%20of%20vintage%20cinema%20film%20frames%20and%20light%20flare%20in%20warm%20amber%20and%20cream%2C%20abstract%20editorial%20photography&width=640&height=480&seq=feed-lens-01&orientation=landscape' },
  { id: 'n5', cat: '综艺名场面', title: '爆款主题曲翻唱挑战刷屏，短视频平台接力升温', summary: '从乐器合奏到方言翻唱，一支主题曲带火全平台二创。官方下场转发高光作品，话题传播还在持续扩散，成为本周当之无愧的“背景音担当”。', time: '昨天 17:12', reads: '11.1 万', trend: '+29%', img: 'https://readdy.ai/api/search-image?query=warm%20music%20studio%20scene%20with%20guitar%20microphone%20and%20vinyl%20records%20on%20wooden%20table%2C%20golden%20light%2C%20editorial%20collage%20aesthetic&width=640&height=480&seq=feed-music-01&orientation=landscape' },
  { id: 'n6', cat: '圈内要闻', title: '颁奖礼红毯造型盘点：谁穿对了风格，谁又被吐槽', summary: '多位造型师从剪裁、配色到品牌呼应逐套点评，一份“红毯红黑榜”在网络热传。时尚媒体提醒，红毯审美本就主观，不必过度较真。', time: '昨天 15:30', reads: '8.7 万', trend: '+12%', img: 'https://readdy.ai/api/search-image?query=elegant%20evening%20gala%20backdrop%20in%20warm%20champagne%20and%20gold%20tone%20with%20soft%20bokeh%20lights%2C%20cinematic%20editorial%20photography&width=640&height=480&seq=feed-redcarpet-01&orientation=landscape' },
];

export const learnPoints: string[] = [
  '先看信源：同一个“瓜”，优先选择媒体通稿、当事方本人发声或现场一手记录，别只信转述截图。',
  '分清事实与观点：谁说了什么、何时发生属于事实；怎么解读、是否“故意炒作”属于观点，两者不要混为一谈。',
  '给热度降速：热度最高的 24 小时内信息最混乱，很多反转发生在“热得过头”之后，让子弹飞一会儿再下结论。',
  '理性表达：吃瓜归吃瓜，不造谣、不网暴、不人肉，讨论停留在事件本身，才是对每个当事人基本的尊重。',
];

export const faqs: FaqItem[] = [
  { q: '“今日大瓜”是什么？是某个具体的事件吗？', a: '“今日大瓜”是一个持续更新的资讯主题，指当下被广泛讨论、大家争相了解的娱乐与流行热点。本站每天整理当天讨论度最高的话题，并帮你看懂来龙去脉，而不是指某一个固定的单一事件。' },
  { q: '你们会捏造消息或制造谣言吗？', a: '不会。我们只做公开信息的客观梳理与转述，不进行定性判断，也不会虚构当事人发言。所有内容都会提示你“以官方与当事方说明为准”，发现事实更新会第一时间补充说明。' },
  { q: '为什么同一个瓜会出现截然相反的两种说法？', a: '因为很多热点在信息不完整时就会上热搜，大家依据各自的碎片信息做出解读，方向自然不同。这正是我们在内容里强调“分清事实与观点”的原因——真相往往需要等更多一手信息浮出水面。' },
  { q: '如何判断一条娱乐消息是否可信？', a: '可以按三步走：一看发布账号是否是媒体通稿或当事方本人；二看内容是否给出可查的时间、地点与原始素材；三看是否有现场一手记录交叉印证。三方对得上，可信度通常更高。' },
  { q: '吃瓜为什么还要“理性”？', a: '因为热搜背后是真实的人与真实的工作。理性吃瓜不是不讨论，而是不造谣、不网暴、不人肉，让表达留在事件本身。这样既保护当事人，也让讨论环境更健康。' },
];

export const reviews: ReviewItem[] = [
  { name: '通勤族 · 小林', role: '早晚高峰刷', text: '标题是真的救命，一句话就把这个瓜讲的是谁、为什么吵、现在到哪步讲清楚了，地铁上一分钟就看完。', stars: 5 },
  { name: '学生党 · 阿雅', role: '睡前追更', text: '最喜欢“理清来龙去脉”那种排版，不用在几十个帖子里来回跳，也不会被标题党带偏，更新还挺勤。', stars: 5 },
  { name: '上班族 · 老王', role: '午休充电', text: '理性吃瓜那几段写得特别走心，看多了撕来撕去，这里能让人静下来，建议每个吃瓜网站都学学。', stars: 4 },
];

export const newsletterFeatures: string[] = [
  '每日 08:00 推送当日头号大瓜解读',
  '每周一期的「吃瓜周报」精品盘点',
  '重要反转第一时间补充说明',
  '随时退订，绝不打扰',
];